import { useId } from 'react';
import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FormError } from '@/components/ui/form-field';

interface PromoCodeInputProps {
  promoCode: string | null;
  onPromoCodeChange: (value: string) => void;
  onApply: () => void;
  onRemove: () => void;
  isPromoApplied: boolean;
  isPromocodeInvalid: boolean;
  promocodeMessage: string;
  isLoading: boolean;
  inputResetKey: number;
}

export default function PromoCodeInput({
  onPromoCodeChange,
  onApply,
  onRemove,
  isPromoApplied,
  isPromocodeInvalid,
  promocodeMessage,
  isLoading,
  inputResetKey,
}: PromoCodeInputProps) {
  const inputId = useId();
  const errorId = `${inputId}-error`;

  return (
    <div className="mt-5">
      <Label htmlFor={inputId} className="mb-2 font-normal">
        Have a Promo Code?
      </Label>

      <div className="flex items-start gap-2">
        <div className="flex-1">
          <Input
            key={inputResetKey}
            id={inputId}
            name="promo-code"
            type="text"
            disabled={isPromoApplied}
            aria-invalid={isPromocodeInvalid || undefined}
            aria-describedby={isPromocodeInvalid ? errorId : undefined}
            onBlur={(e) => onPromoCodeChange(e.target.value)}
            data-testid="promo-code_id"
            className={isPromocodeInvalid ? 'border-destructive' : ''}
          />
        </div>
        {!isPromoApplied ? (
          <Button
            type="button"
            variant="outline"
            disabled={isLoading}
            onClick={onApply}
          >
            {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
            Apply
          </Button>
        ) : (
          <Button type="button" variant="outline" onClick={onRemove}>
            Remove
          </Button>
        )}
      </div>

      {isPromocodeInvalid && (
        <FormError id={errorId} message={promocodeMessage} />
      )}
    </div>
  );
}
